import React, {useEffect, useState} from 'react';
import Header from '../layout/Header';
import Sidebar from '../layout/Sidebar';
import Footer from '../layout/Footer';
import ProfileHeader from '../layout/ProfileHeader';
import Breadcrumbs from '../Reusables/Breadcrumbs';
import { useDispatch } from 'react-redux';
import { parseBreadcrumbsList, parseDataList, parseUserName } from '../../store/Actions';
import Spinner from '../Reusables/Spinner';
import '../../scss/profile.scss';
import profile from '../../images/common/profile.png';
import edit from '../../images/common/edit-blue.png';
import getProfile from '../actions/Profile';
import { useSelector } from 'react-redux';
import Users from './Users';
// import Roles from '../pages/Roles';
import { Navigate, useNavigate, useLocation } from 'react-router';
import downArrow from '../../images/common/bluedownarrow.png';
import upArrow from '../../images/common/blueuparrow.png';
import upload_placeholder from '../../images/common/upload-placeholder.png';
import { parseUserlogo } from '../../store/Actions'
import RefreshToken from '../actions/RefreshToken';
import Snackbars from '../Reusables/Snackbar';
import { trim } from '../Reusables/Function';
import ResetPassword from '../popups/ResetPassword';

function Profile() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location  = useLocation();
    const countryCodes = require('country-codes-list');
    const userId = useSelector((state) => state.userId);
    const[isLoading, setLoading] = useState(true);
    const [isShowEdit, setShowEdit] = useState(null);
    const [callingCodes, setCallingCodes] = useState([]);
    const [role, setRole] = useState([]);
    const [Firstname, SetFname] = useState('');
    const [Lastname, SetLname] = useState('');
    const [email, SetEmail] = useState('');
    const [description, SetDescription] = useState('');
    const [file, setFile] = useState(null);
    const imageUploader = React.useRef(null);
    const [isDeleted, setDelete] = useState(false);
    const countryCallingCodeObject = countryCodes.customList('countryCode', '+{countryCallingCode}');
    const [profiledata, setProfiledata] = useState({});
    const [errormessage, setErrorMessage] = useState('');
    const [removelogo, setRemovelogo] = useState(false);
    const [open, setOpen] = useState(null);
    const [enable, setEnable] = useState(true);
    const [values, setValues] = useState({
        countryDropdownClick1: false,
        countryCodeDropdownClick1: false,
        countryCode1: "+1",
        phone1: null,
        countryDropdownClick: false,
        countryCodeDropdownClick: false,
        countryCode: null,
        roleId: null,
        logoUrl: null,
        notificationTypes: []
    })
    // const [profiledata, setProfiledata] = useState({});
    const breadcrumbsListProfile = [
        { "name": "Home", "url": "" },
        { "name": "Profile", "url": "profile" }
    ];

    const [showResetPassword, setShowResetPassword] = useState(false);
    const handleCloseResetPasswordPopup = () => setShowResetPassword(false);
    const handleShowResetPasswordPopup = () => setShowResetPassword(true);

    const handleCountryCodeDropdown1 = () => {
        setValues({
            ...values,
            countryCodeDropdownClick1: !values.countryCodeDropdownClick1
        })
    }
    const getCountryCode1 = (e) => {
        setValues({
            ...values,
            countryCodeDropdownClick1: !values.countryCodeDropdownClick1,
            countryCode1: e.target.innerText
        })
    }
    const handleCountryCodeDropdown = () => {
        setValues({
            ...values,
            countryCodeDropdownClick: !values.countryCodeDropdownClick
        })
    }
    const getCountryCode = (e,id) => {
        setValues({
            ...values,
            countryCodeDropdownClick: !values.countryCodeDropdownClick,
            countryCode: e.target.innerText,
            roleId: id
        })
    }
    useEffect(() => {
        window.scroll(0, 0);
        let countryCode, phoneNum, role, url = '';
        let code
        dispatch(parseBreadcrumbsList(breadcrumbsListProfile));
        function CallAPI(accesstoken) {
            console.log('first 1');
            if(accesstoken === '') {
                navigate('/login');
            }
            else if(accesstoken === 'noToken') {
                console.log('location [Profile]');
                navigate('/login', {state : {path : window.location.pathname+window.location.search+window.location.hash}});
            }
            else {
                getProfile.ProfileInfo((`/api/users/info?userId=${userId}`), accesstoken, (data)=> {
                    if(data.status == 200) {
                        setProfiledata(data.data.data)
                        code = data.data.data;
                        SetFname(code.firstName);
                        SetLname(code.lastName);
                        SetEmail(code.email);
                        setLoading(false);
                        SetDescription(code.description)

                        var notificationTypesArray = [];
                        if(code.selectedNotificationTypes != null && code.selectedNotificationTypes.length > 0) {
                            notificationTypesArray = code.selectedNotificationTypes.map(item => item.idNotificationType);
                        }

                        setValues({
                            countryCode1: code.countryCode,
                            phone1: code.phoneNumber,
                            logoUrl: code.profileUrl,
                            notificationTypes: notificationTypesArray
                        }) 
                        var rolesArray = []
                        code.selectedRoles != null && code.selectedRoles.map((item) => {
                        rolesArray.push(item.idRoles);
                        })
                        setRole(rolesArray)
                        setOpen(false);
                    } else if(data.status == 401) {
                        navigate("/login")
                    }
                })
            }
        }
        RefreshToken((accesstoken) => CallAPI(accesstoken));
        // getProfile.GetRole((`/api/roles`),(data)=> {
        //     // setRole(data.data.data)
        //     const codes = data.data.data
        //     role = codes.roleName
        // })
        getCountryCodeArray();
    },[isDeleted])
    useEffect(() => {
        const path = window.location.href;
        const pathSplit = path.split('/');
        const id = parseInt(pathSplit[pathSplit.length - 2]);
        const pageType = pathSplit[pathSplit.length - 1];
        pageType == "edit"? setShowEdit(false) : setShowEdit(true);
        
    },[isShowEdit, location])
    const getCountryCodeArray = () => {
        const countryCallingCodeArray = [];
        Object.keys(countryCallingCodeObject).forEach((key) => {
            if(!countryCallingCodeArray.includes(countryCallingCodeObject[key])) {
                countryCallingCodeArray.push(countryCallingCodeObject[key].replace(/ /g, ''));
            }
        });
        setCallingCodes(countryCallingCodeArray.sort());
    }
    function setPhoneNumbers1(value) {
        setValues({
            ...values,
            phone1: value
        })
    }
    const handleFname = (value) => {
        SetFname(value)
    }
    const handleLname = (value) => {
        SetLname(value)
    }
    const handleEmail = (value) => {
        SetEmail(value)
    }
    const handleDescription = (value) => {
        SetDescription(value)
    }
    const updateValues = (url) => {
        const details = {
            UserId: userId,
            FirstName: trim(Firstname),
            LastName: trim(Lastname),
            Email: trim(email),
            CountryCode: values.countryCode1,
            PhoneNumber: trim(values.phone1),
            ProfileUrl: url,
            Roles: role,
            Description: trim(description),
            NotificationTypes: values.notificationTypes
        }
        return details
    }
    const getFormData = (id, type) => {
        const formData = new FormData();
        formData.set('UserId', userId);
        formData.set('Profile', file)
        return formData
    }
    const saveProfile = () => {
        setEnable(false);
        var details = null;
        if(Firstname !== '' && Firstname !== undefined && Firstname !== null) {
            var firstName = trim(Firstname);
        }
        else {
            var firstName = '';
        }
        if(Lastname !== '' && Lastname !== undefined && Lastname !== null) {
            var lastName = trim(Lastname);
        }
        else {
            var lastName = '';
        }
        var name = firstName +' '+lastName;
        console.log(name)
        // dispatch(parseUserName(name));
        function CallAPI(accesstoken) {
            if(accesstoken === '') {
                navigate('/login');
            }
            else {
                console.log(file)
                if(file != null) {
                    const formData = getFormData();
                    getProfile.Profileupload('/api/users/profile/upload', formData, accesstoken, (data) => {
                        if(data.status == 200) {
                            dispatch(parseUserlogo(data.data.logoUrl))
                            details = updateValues(data.data.logoUrl);
                            getProfile.EditProfile(details, `/api/users/edit`, accesstoken, (data) => {
                                setEnable(true);
                                if (data.status == 200) {
                                    setLoading(true);
                                    setDelete(!isDeleted);
                                    navigate("/profile");
                                    setShowEdit(true);
                                    setErrorMessage('');
                                    setOpen(false);
                                    dispatch(parseUserName(name));
                                }
                                else if(data.status == 400 || data.status == 404) {
                                    setLoading(false);
                                    setErrorMessage(data.data.message);
                                    setOpen(true);
                                } else if(data.status == 401) {
                                    navigate("/login")
                                }
                            });
                        } else {
                            setEnable(true);
                        }
                    })
                } else {
                    if(removelogo) {
                        const formData = new FormData();
                        formData.set('UserId', userId);
                        getProfile.Profileupload('/api/users/profile/upload', formData, accesstoken, (data) => {
                            if(data.status == 200) {
                                console.log(data.data.logoUrl)
                                dispatch(parseUserlogo(data.data.logoUrl))
                                details = updateValues(data.data.logoUrl);
                                setValues({
                                    ...values,
                                    logoUrl: data.data.logoUrl
                                })
                                getProfile.EditProfile(details, `/api/users/edit`, accesstoken, (data) => {
                                    setEnable(true);
                                    if (data.status == 200) {
                                        setDelete(!isDeleted);
                                        navigate("/profile");
                                        setShowEdit(true)
                                        // dispatch(parseUserlogo(values.logoUrll))
                                        setErrorMessage('')
                                        setOpen(false);
                                        dispatch(parseUserName(name));
                                        setLoading(true);
                                    }
                                    else if(data.status == 400 || data.status == 404) {
                                        setErrorMessage(data.data.message);
                                        setOpen(true);
                                        setLoading(false);
                                    } else if(data.status == 401) {
                                        navigate("/login")
                                    }
                                });
                            } else {
                                setEnable(true);
                            }
                        })
                    } else {
                        details = updateValues(values.logoUrl);
                        getProfile.EditProfile(details, `/api/users/edit`, accesstoken, (data) => {
                            setEnable(true);
                            if (data.status == 200) {
                                setLoading(true);
                                setDelete(!isDeleted);
                                navigate("/profile");
                                setShowEdit(true)
                                setErrorMessage('')
                                setOpen(false);
                                dispatch(parseUserName(name));
                            }
                            else if(data.status == 400 || data.status == 404) {
                                setLoading(false);
                                setErrorMessage(data.data.message);
                                window.scroll(0,0)
                                setOpen(true);

                            } else if(data.status == 401) {
                                navigate("/login")
                            }
                        });
                    }
                }
            }
        }
        RefreshToken((accesstoken) => CallAPI(accesstoken));
    } 
    const EditProfile = () => {
        navigate(`/profile/${userId}/edit`);
        setShowEdit(!isShowEdit);
        setEnable(true);
    }
    const UploadLogo = e => {
        const [file] = e.target.files;
        setFile(file);
        if (file) {
          const reader = new FileReader();
          reader.onload = e => {
            setValues({
                ...values,
                logoUrl: e.target.result
            })
          };
          reader.readAsDataURL(file);
        }
    }
    const RemoveLogo = () => {
        setRemovelogo(true);
        const formData = new FormData();
        setFile(null)
        formData.set('UserId', userId);
        setValues({
            ...values,
            logoUrl: profile
        })
    }

    const handleReset = () => {
        handleShowResetPasswordPopup();
        setErrorMessage('')
        setOpen(false)
    }

    const handleResetPassword = (details) => {
        details.UserId = userId

        const callApi = (accesstoken) => {
            if(accesstoken === '') {
                navigate('/login');
            }
            else {
                if((details.NewPassword != null && details.NewPassword != "") || (details.ConfirmPassword != null && details.ConfirmPassword != "")) {
                    getProfile.ResetPassword('/api/users/reset/password', accesstoken, details, (data) => {
                        if (data.status == 200) {
                            handleCloseResetPasswordPopup();
                            setErrorMessage('');
                            setOpen(false)
                        }
                        else if(data.status == 400 || data.status == 404) {
                            handleShowResetPasswordPopup();
                            setErrorMessage(data.data.message)
                            setOpen(true)
                        } else if(data.status == 401) {
                            navigate("/login")
                        }
                    });
                }
            }
        }

        RefreshToken((accesstoken) => callApi(accesstoken));
    }

    return (
        <div className="my-profile-container">
            <Header />
            <div className="row profile-tab-breadcrumbs">
                <Sidebar />
                <div className='col-10 brands-body-container'>
                    <div className='sub-header'>
                        <Breadcrumbs/>
                    </div>
                    <div className="profile-header-tab">
                        <ProfileHeader/>
                        {/* Profile Page */}
                        {isLoading ? 
                            (<Spinner/>) : (
                        <div className="myprofile-tab">
                            <div className="display-edit">
                                <h2 className="profile-text">My Profile</h2>
                                {isShowEdit && 
                                <div className='actions-container'>
                                    <button className="reset-password"  onClick={handleReset}>Reset Password</button>
                                    <div className="overview-profile"><img src={edit} onClick={EditProfile}/></div>
                                </div>}
                            </div>
                            <div className="row profile-content">
                                <div className="col-2 profile-image-tag">
                                    <img src={values.logoUrl} className="profile-image"/>
                                    {!isShowEdit ? <>
                                    <input type="file" accept="image/*" className="upload-logo-input" onChange={UploadLogo} ref={imageUploader}/>
                                    <div className='upload-logo-text' onClick={() => imageUploader.current.click()}>
                                        Upload Profile Image
                                    </div> 
                                    <input  className="remove-logo" onClick={RemoveLogo}  value="Delete Profile Image" readOnly/></> : ''
                                    }
                                </div>
                                <div className="col-10">
                                    <div className="name-label">
                                        <div className="label-fname">
                                            {!isShowEdit ? <label className="min-inline-size label-color required">First Name</label> : <label className="min-inline-size">First Name</label>}
                                            {isShowEdit ? <div className="edit-label-overview">{Firstname}</div> :
                                            <input className="input-edit-label input-edit" value={Firstname} onChange={(e) => handleFname(e.target.value)} maxLength={45}/>
                                            }
                                        </div>
                                        <div className="label-fname">
                                            {!isShowEdit ? <label className="label-color" >Last Name</label> : <label>Last Name</label>}
                                            {isShowEdit ? <div className="edit-label-overview">{Lastname}</div> :
                                            <input className="input-edit-label input-edit " value={Lastname} onChange={(e) => handleLname(e.target.value)} maxLength={45}/>
                                            }
                                        </div>
                                    </div>
                                    <div className="content-label">
                                        <div className="label-fname">
                                            {!isShowEdit ? <label className="min-inline-size required label-color">Phone Number</label> : <label className="min-inline-size">Phone Number</label>}
                                            {!isShowEdit ? 
                                                <div className="flex-display">
                                                    <div className="position-edit">
                                                        <div className='dropdown dropdown-country-code-container'>
                                                            <div className='dropdown-name-img dropdown-country-code' onClick={handleCountryCodeDropdown1}>
                                                                <div className='dropdown-name dropdown-label'>{values.countryCode1}</div>
                                                                <div className="country-arrow"><img className='arrow' src={values.countryCodeDropdownClick1 ? upArrow : downArrow} alt=""></img></div>
                                                            </div>
                                                            {values.countryCodeDropdownClick1 &&
                                                                <div className='dropdown-list'>
                                                                    {
                                                                        callingCodes.length > 0 && callingCodes.map((item, index) => {
                                                                            return (
                                                                                <div className='dropdown-content-inner countrycode-dropdown-inner' key={index} 
                                                                                onClick={(event) => getCountryCode1(event)}>{item}</div>
                                                                            )
                                                                        })
                                                                    }
                                                                </div>
                                                            }
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <input className="input-edit-label" type="text" value={values.phone1} onChange={(e) => setPhoneNumbers1(e.target.value)} maxLength={15}></input>
                                                    </div>
                                                </div> :
                                                <div className="edit-label-overview">{profiledata.phoneNumber}</div>
                                            }
                                        </div>
                                        <div className="label-fname">
                                            {!isShowEdit ? <label className="required label-color">Email Id</label> : <label>Email Id</label>}
                                            {isShowEdit ? <div className="edit-label-overview">{email}</div> :
                                            <input className="input-edit-label email input-edit" type="email" name="email" value={email} onChange={(e) => handleEmail(e.target.value)} 
                                            readOnly={!isShowEdit ? false: true} maxLength={45}/>
                                            }
                                        </div>
                                    </div>
                                    <div className="description-label">
                                        <div className="label-fname">
                                            {!isShowEdit ? <label className="label-color">Description</label> : <label>Description</label>}
                                            {
                                                isShowEdit ? <div className="edit-label-overview">{description}</div> :
                                            <textarea maxLength={1000} rows="3" className="textarea-label-edit" type="text" value={description} onChange={(e) => handleDescription(e.target.value)}/>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {
                                !isShowEdit ?
                                <div className="edit-tag-button">
                                    <hr />
                                    <button disabled={enable ? false : true} className={enable ? 'profile-edit-save enable' : 'profile-edit-save disable'} onClick={saveProfile}>Save</button>
                                </div> : ''
                            }
                        </div>)}
                        <Snackbars error={errormessage} open={open} setOpen={setOpen}/>
                    </div>
                </div>
            </div>
            
            <Footer />

            {/* Showing reset password popup */}
            <ResetPassword  errormessage ={null} show={showResetPassword} handleClose={handleCloseResetPasswordPopup} 
                resetPasswordApiCall={(details) => handleResetPassword(details)}/>
        </div>
    )
}
export default Profile;